import styled, { css } from 'styled-components';

import { MarkdownDisplayWrapper } from '@web/components/MarkdownDisplayWrapper';

type WrapperProps = {
  maskEnabled: boolean;
  contentHeight: number;
};

export const ContentWrapper = styled.div<WrapperProps>`
  overflow: hidden;
  position: relative;
  height: ${({ contentHeight }) => contentHeight}px;
  ${({ maskEnabled }) =>
    maskEnabled &&
    css`
      mask-image: linear-gradient(to bottom, black 0% calc(90% - 50px), transparent 90% 100%);
    `}
`;

type ContentProps = {
  offsetTop: number;
};

export const Content = styled(MarkdownDisplayWrapper)<ContentProps>`
  position: absolute;
  top: -${({ offsetTop }) => offsetTop}px;
  left: 0;
`;
